import { render, staticRenderFns } from "./FeatureMassCopy.vue?vue&type=template&id=11005b46"
import script from "./FeatureMassCopy.vue?vue&type=script&lang=js"
export * from "./FeatureMassCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports